// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/adm-fundamentals.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/adm-fundamentals/adm-fundamentals.js';

mount([g0]);
